import { Component, OnInit } from '@angular/core';


interface data {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-ops-vendor-info',
  templateUrl: './ops-vendor-info.component.html',
  styleUrls: ['./ops-vendor-info.component.css']
})
export class OpsVendorInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  custs: data[] = [
    { value: 'FREEDOM-1', viewValue: 'FREEDOM' },
    { value: 'XOME-2', viewValue: 'XOME' },
    { value: 'PROTECK-3', viewValue: 'PROTECK' },
    { value: 'BK EMPOWER-4', viewValue: 'BK EMPOWER' },
    { value: 'FREEDOM XPANSE-5', viewValue: 'FREEDOM XPANSE' },
  ];

  status: data[]=[
    { value:'all',viewValue:'All'},
    { value:'payable,',viewValue:'Payable'},
    { value:'notpayable',viewValue:'Not Payable'}
  ];

  public ShowFilters: boolean = true;
  public buttonName: any = 'Show Filters';

  toggle() {
    this.ShowFilters = !this.ShowFilters;
    if (this.ShowFilters)
      this.buttonName = "Hide Filters";
    else
      this.buttonName = "Show Filters";
  }

}
